'use client';

import { SidebarTrigger } from "./ui/sidebar";
import { usePathname } from 'next/navigation';



export default function CustomTrigger() {
    const pathname = usePathname();
  
    if (pathname !== '/login' && pathname !== '/'){
    return (
      <>
      <SidebarTrigger/>
      </>
        
    )
    }
    else {
      return null
    }
}